import { removeNamespace } from "../../utils/helpers"
import $http from "@/plugins/axios"

export const VERIFICATION_REQUESTS_TYPES = {
  mutations: {
    SET_LOADING: "verificationRequests/SET_LOADING",
    SET_PAGED_REQUESTS: "verificationRequests/SET_PAGED_REQUESTS",
    SET_REQUESTS_COUNT: "verificationRequests/SET_REQUEST_COUNT",
    SET_REQUEST_TABLE_OPTIONS: "verificationRequests/SET_REQUEST_TABLE_OPTIONS",
    SET_KEYWORD: "verificationRequests/SET_KEYWORD",
    SET_SEARCH_DATES: "verificationRequests/SET_SEARCH_DATES",
    SET_SEARCH_STATUS: "verificationRequests/SET_SEARCH_STATUS",
    RESET: "verificationRequests/RESET"
  },
  actions: {
    fetchRequestsPaged: "verificationRequests/fetchRequestsPaged",
    search: "verificationRequests/search",
    getEvaluationCopyRequestReportFile: "verificationRequests/getEvaluationCopyRequestReportFile"
  }
}

const _types = removeNamespace(
  "verificationRequests",
  VERIFICATION_REQUESTS_TYPES
)

const state = () => ({
  loading: false,
  requestTableOptions: {
    page: 1,
    itemsPerPage: 20,
    keyword: "",
    searchType: null,
    orderBy: null,
    orderDescending: false
  },
  rawTableOptions: null,
  pagedRequests: [],
  requestsCount: 0,
  searchStartDate: null,
  searchEndDate: null,
  searchStatus: null
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_PAGED_REQUESTS] (state, pagedRequests) {
    state.pagedRequests = pagedRequests
  },
  [_types.mutations.SET_REQUESTS_COUNT] (state, count) {
    state.requestsCount = count
  },
  [_types.mutations.SET_SEARCH_DATES] (state, dates) {
    state.searchStartDate = dates[0]
    state.searchEndDate = dates[1]
  },
  [_types.mutations.SET_SEARCH_STATUS] (state, status) {
    state.searchStatus = status
  },
  [_types.mutations.SET_REQUEST_TABLE_OPTIONS] (state, tableOptions) {
    state.rawTableOptions = tableOptions
    const { page, itemsPerPage, keyword, searchType } = tableOptions

    state.requestTableOptions = {
      page,
      itemsPerPage,
      keyword,
      searchType,
      orderBy: tableOptions.sortBy.length > 0 ? tableOptions.sortBy[0] : null,
      orderDescending:
        tableOptions.sortDesc.length > 0 ? tableOptions.sortDesc[0] : null
    }
  },
  [_types.mutations.SET_KEYWORD] (state, keyword) {
    state.requestTableOptions.keyword = keyword
  },
  [_types.mutations.RESET] (state) {
    state.requestTableOptions = {
      page: 1,
      itemsPerPage: 10,
      keyword: "",
      searchType: null,
      orderBy: null,
      orderDescending: false
    }
  }
}

const actions = {
  [_types.actions.fetchRequestsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const {
      itemsPerPage,
      page,
      keyword,
      orderBy,
      orderDescending
    } = state.requestTableOptions
    const maxResultCount = itemsPerPage
    const skipCount = (page - 1) * itemsPerPage
    return $http()
      .get("admin/EvaluationCopyRequest/paged", {
        params: {
          skipCount,
          maxResultCount,
          keyword,
          orderBy,
          startDate: state.searchStartDate,
          endDate: state.searchEndDate,
          selectedStatus: state.searchStatus,
          orderDescending: orderDescending ?? false
        }
      })
      .then(res => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_REQUESTS, items)
        commit(_types.mutations.SET_REQUESTS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.search] ({ state, commit, dispatch }, payload) {
    commit(_types.mutations.RESET)
    commit(_types.mutations.SET_KEYWORD, payload)
    dispatch(_types.actions.fetchRequestsPaged)
  },
  [_types.actions.getEvaluationCopyRequestReportFile] ({ state, commit }, { keyword, dates, status }) {
    commit(_types.mutations.SET_LOADING, true)
    return $http()
      .get("admin/EvaluationCopyRequest/getEvaluationCopyRequestReportFile", {
        params: {
          keyword,
          startDate: dates[0],
          endDate: dates[1],
          selectedStatus: status,
          orderBy: state.requestTableOptions.orderBy,
          orderDescending: state.requestTableOptions.orderDescending ?? false
        }
      })
      .then(res => {
        return res
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
